import { render, staticRenderFns } from "./abroad-summary.vue?vue&type=template&id=f3dbfd42&scoped=true&"
import script from "./abroad-summary.vue?vue&type=script&lang=js&"
export * from "./abroad-summary.vue?vue&type=script&lang=js&"
import style0 from "./abroad-summary.vue?vue&type=style&index=0&id=f3dbfd42&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3dbfd42",
  null
  
)

export default component.exports